import { ChangeEvent, FormEvent, useState } from 'react'

import { LIST_SENDGRID_NAMES } from 'constants/constant'
import { useDataLayer, useEmailSubsribeContactList } from 'hooks'
import { Typography, Button, Input } from '~ui'

import styles from './Subscribe.module.scss'

const { Text, Paragraph } = Typography

const Subscribe = () => {
  const [mutate, { error, loading }] = useEmailSubsribeContactList()

  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'success' | 'failure'>(null)

  const dl = useDataLayer()

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()

    if (loading || !email) return

    const { data } = await mutate({
      variables: {
        listNames: [
          LIST_SENDGRID_NAMES.SUBSCRIBE_FORM_TOUR_PAGE,
          LIST_SENDGRID_NAMES.general_welcome_series,
        ],
        data: { email },
      },
    })

    if (data.addOrUpdateContactList.__typename === 'ContactMutationFailure') {
      setStatus('failure')
      return
    }

    setStatus('success')
    dl.push({
      event: 'subsribe_for_mailing',
      type: 'tour-page',
    })
  }

  if (status === 'success')
    return (
      <Text color="g-green" center>
        Thanks for subscribing! We&apos;ll notify you when Granted exclusive events go on sale.
      </Text>
    )

  if (error || status === 'failure')
    return (
      <Text color="red" center>
        Something went wrong.
      </Text>
    )

  return (
    <div className={styles.wrapper}>
      <Paragraph>Be the first to know when exclusive Granted experiences go on sale!</Paragraph>
      <form onSubmit={onSubmit}>
        <Input
          onChange={onChange}
          value={email}
          type="email"
          name="email"
          placeholder="Email Address"
        />
        <Button type="submit" variant="primary" loading={loading} disabled={loading}>
          {loading ? 'Subscribing...' : 'Subscribe'}
        </Button>
      </form>
    </div>
  )
}

export default Subscribe
